/**
 * Renders the Picker by using the data from the page context (API data from dynamic section)
 */
import { ControlProps, RankedTester, rankWith, Test } from '@jsonforms/core';
import { useJsonForms, withJsonFormsOneOfEnumProps } from '@jsonforms/react';
import React from 'react';
import _ from 'lodash';

import { SpectrumInputControl } from './SpectrumInputControl';
import { InputEnum } from '../spectrum-control/InputEnum';

export const SpectrumContextPickerControl = (props: ControlProps) => {

  const context = useJsonForms();
  const config = context.config;

  const uischema = props.uischema;
  const dataSource = uischema.options?.dataSource;
  const name = uischema.options?.name;

  const transformData =
    config?.lifecycleHooks?.contextPicker?.transformData;

  if (!dataSource) {
    console.error('dataSource is not defined in the uischema.options');
  }

  // Data source type is assumed as context, if a new data source type is added, it should be handled.

  const contextKey = dataSource.value;
  if (!contextKey) {
    console.error(
      'Context key is not defined in the uischema.options.dataSource'
    );
  }
  const pageContext = config.pageContext;


  const contextData = _.get(pageContext, contextKey);


  if (!contextData) {
    console.error(`contextData for key '${contextKey}' does not exists`);
    return null;
  }

  let options = [];

  if (transformData) {
    options = transformData(name, contextData);
  } else {
    options = contextData;
  }


  return (
    <SpectrumInputControl {...props} options={options} input={InputEnum} />
  );
};

const isContextPickerTrue: Test.Tester = (uischema: any) =>
  uischema?.options?.contextPicker;

export const spectrumContextPickerControlTester: RankedTester = rankWith(
  5,
  isContextPickerTrue
);

export default withJsonFormsOneOfEnumProps(SpectrumContextPickerControl);
